import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PartnerExternal } from './partner-form-external'
import { formUpdater } from '../../utils'
import PartnerInternal from './partner-form-internal'

const DEFAULT_STORE_KEY = 'organizationForm'

const PartnerForm = ({
  storeKey = DEFAULT_STORE_KEY,
  setActivePartnerForm,
  form,
  updateForm,
  handleCancel = () => {},
  excludes
}) => {
  const dispatch = useDispatch();
  const { active_form } = useSelector((state) => state[storeKey]?.partner);

  const [formExternal, setFormExternal] = useState({});

  const updateFormExternal = (e) =>
    formUpdater(e, formExternal, setFormExternal);

  const handleImage = (e) => {
    setFormExternal({
      ...formExternal,
      image: URL.createObjectURL(e),
      image_meta: {
        name: e.name,
        type: e.type,
        blob: URL.createObjectURL(e),
      },
    });
  };

  const handleSaveLocal = () => {
    console.log(formExternal);
    let cloned = { ...formExternal };

    if (!formExternal.id) {
      cloned.id = new Date().toISOString();
    }

    dispatch(
      updateForm({
        key: "partners_external",
        value: [...form.partners_external, cloned],
      })
    );

    handleCancel();
  };

  return (
    <div>
      {active_form === "internal" && (
        <div>
          <PartnerInternal
            form={form}
            updateForm={updateForm}
            setActivePartnerForm={setActivePartnerForm}
            excludes={excludes}
          />
        </div>
      )}
      {active_form === "external" && (
        <div className="lg:w-3/4">
          <PartnerExternal
            handleImage={handleImage}
            handleCancel={handleCancel}
            handleSave={handleSaveLocal}
            updateForm={updateFormExternal}
          />
        </div>
      )}
    </div>
  );
};

export { PartnerForm }
